






































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import LanguageGroup from "@/models/language/languageGroup/languageGroup.model";

@Component
export default class LanguageGroupAdd extends GenericAdd<LanguageGroup> {
  constructor() {
    super();
    this.controller = "LanguageGroups";
    this.model = new LanguageGroup();
  }

  saveAll() {
    this.model.languageId = this.$route.params.languageId as any;
    return this.validate();
  }
}
